// extracted by mini-css-extract-plugin
export var bottom = "footer-module--bottom--Yx75y";
export var card = "footer-module--card--7vd9B";
export var container = "footer-module--container--7mJ6H";
export var cookie = "footer-module--cookie---zxhj";
export var fixedButton = "footer-module--fixedButton--Erjfy";
export var icon = "footer-module--icon--akyD4";
export var links = "footer-module--links--zePCA";
export var phone = "footer-module--phone--PFXhq";
export var top = "footer-module--top--oeYhO";